export default __webpack_public_path__ + "static/media/daylotts_terms_of_service.968b8eec.pdf";